import {DomainEvent} from './DomainEvent';
import {Profile} from '../resources/Profile';

export class ProfileCreated extends DomainEvent<Profile> {}
